import React from 'react';
import { Outlet } from 'react-router-dom';

function MainLayout(props) {
    return (
        <Outlet />
    );
}

export default MainLayout;